import { z } from 'zod';
import { defineEndpoint } from '../define';
import {
  DeviceOsSchema,
  DeviceRowSchema,
  DeviceStatusSchema,
  InventoryFieldsSchema,
} from './shapes';

const EditableStatusSchema = z.enum(['available', 'lost', 'retired']);

export const UpdateDeviceBodySchema = z
  .object({
    name: z.string().trim().min(1).max(120).optional(),
    model: z.string().trim().max(120).optional(),
    os: DeviceOsSchema.optional(),
    serial: z.string().trim().max(120).optional(),
    imei: z.string().trim().max(40).optional(),
    status: EditableStatusSchema.optional(),
    notes: z.string().trim().max(2000).optional(),
  })
  .merge(InventoryFieldsSchema.partial())
  .refine((data) => Object.values(data).some((v) => v !== undefined), {
    message: 'At least one editable field must be present',
  });
export type UpdateDeviceBody = z.infer<typeof UpdateDeviceBodySchema>;

export const UpdateDeviceResponseSchema = z.object({
  data: DeviceRowSchema,
});

export const updateDevice = defineEndpoint({
  method: 'PATCH',
  path: '/v1/devices/:deviceId',
  params: z.object({ deviceId: z.string().uuid() }),
  query: z.object({}),
  body: UpdateDeviceBodySchema,
  response: UpdateDeviceResponseSchema,
});

export { DeviceStatusSchema };
